import { render } from "./AppRadio.vue?vue&type=template&id=6bd9d20d&scoped=true"
import script from "./AppRadio.vue?vue&type=script&lang=js"
export * from "./AppRadio.vue?vue&type=script&lang=js"

import "./AppRadio.vue?vue&type=style&index=0&id=6bd9d20d&scoped=true&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd9d20d"]])

export default __exports__